import React from 'react'

import PageTitle from '../../components/page-title'

function About() {
  return (
    <div>
      <PageTitle title="About" />
    </div>
  )
}

export default About

